import React from "react";
import { useNavigate , useLocation } from "react-router";
import { ArrowLeft } from "lucide-react";

export default function AppConfigurationTitle(props){

        const navigate = useNavigate();
        const location = useLocation();
        
        function goBackToMain(){
            navigate(props.path , { state: { fromPage: location.pathname } });
        }
    
    return(
        <>
        <div className="header-grid">
            <ArrowLeft color="#0C162F" size={48} strokeWidth={3} className="arrow-left" onClick={goBackToMain}/>
            <h1 className="title" >{props.title}</h1>
        </div>
        </>
    )
}